/* eslint-disable @typescript-eslint/naming-convention */
import { currencyMapper } from 'data-source/mappers/currencyMapper'
import { ApiClearBuyPriceBase, ApiDealsPrice } from 'data-source/types.wp'
import { nullableString } from 'shared-code/conversion'
import { DSDealPrice } from 'shared-definitions/types'
import { discountPercentMapper } from './discountPercentMapper'

export function oneDealPriceMapper({
  is_free,
  current_price,
  original_price,
  coupon,
  currency,
  retailer_custom_text,
}: ApiDealsPrice): DSDealPrice {
  const { discount, discountPercent } = discountPercentMapper(current_price, original_price)

  return {
    currency: currencyMapper(currency),
    discount,
    discountPercent,
    coupon: nullableString(coupon),
    isFree: is_free,
    current: current_price ?? null,
    customText: nullableString(retailer_custom_text),
  }
}

export function clearBuyPriceMapper(input: ApiClearBuyPriceBase): DSDealPrice {
  return oneDealPriceMapper({
    is_free: input.is_free === 1 || input.is_free === true,
    currency: input.currency ?? undefined,
    current_price: input.current_price,
    coupon: input.coupon_code ?? undefined,
    original_price: input.original_price ?? undefined,
    retailer_custom_text: input.retailer_custom_text ?? undefined,
  })
}
